import { CouponCode } from "@/components/Cart/components/CouponCode";
import { usePromoCodeComponent } from "@/components/shared/PromoCode/usePromoCodeComponent";
import { EstimateIntervalData } from "@/components/shared/interval-switch/estimate-interval-change";
import { DashboardService } from "../service.dashboard";

const COPY =
  DashboardService.Content.yearlyPlanSaleLedger.switchToday.promoCode;

export interface UpgradePromoCodeProps {
  /** Discounts the estimate echoes back for the applied code */
  discounts: EstimateIntervalData["discounts"];
  onApply: (code: string) => void;
  onRemove: (code: string) => void;
  /** The estimate is refetching with the code */
  isApplying: boolean;
  isDisabled?: boolean;
  /** Nothing is due today, so there is nothing left to discount */
  isZeroAmount: boolean;
  /** Prefills the field, e.g. with a code from the URL */
  initialInputValue?: string;
}

/** Promo code field for the yearly switch; applied codes stay removable once the field hides */
const UpgradePromoCode = ({
  discounts,
  onApply,
  onRemove,
  isApplying,
  isDisabled = false,
  isZeroAmount,
  initialInputValue,
}: UpgradePromoCodeProps) => {
  const promo = usePromoCodeComponent({
    discounts,
    onApplyPromoCode: onApply,
    onRemoveDiscount: onRemove,
    isApplying,
    isDisabled,
    initialInputValue,
  });

  const isFieldShown = !(promo.hasValidDiscount || isZeroAmount);

  return (
    <CouponCode
      isApplying={promo.isApplying}
      {...(isFieldShown && {
        field: {
          placeholder: COPY.placeholder,
          value: promo.inputValue,
          setValue: promo.setInputValue,
          codeInvalid: promo.isInvalidState,
        },
        cta: {
          label: COPY.apply,
          action: promo.handleApply,
          disabled: promo.isDisabled,
        },
      })}
      appliedStates={promo.appliedDiscounts.map((discount) => ({
        ...discount,
        message: COPY.applied,
      }))}
    />
  );
};

export default UpgradePromoCode;
